import FormSelectInput from 'common/FormSelectInput';
import FormTextInput from 'common/FormTextInput';
import { states } from 'pages/Business/Provider/ProviderPopup/Partials/constants';

import { useEffect } from 'react';

export default function License({
    count,
    formData,
    handleChange,
    extraLicenseNumber,
    extraLicenseState,
    extraLicenseYear,
}) {
    return (
        <>
            <FormTextInput
                // formData={formData}
                name="license_number"
                value={extraLicenseNumber?.[count]}
                handleChange={handleChange}
                placeholder="Enter a license number"
                required={false}
                labelSize={0}
                textSize={6}
                noLabel={true}
            />

            <FormSelectInput
                // formData={formData}
                name="license_state"
                value={extraLicenseState?.[count]}
                handleChange={handleChange}
                placeholder="State"
                required={false}
                labelSize={0}
                inputSize={3}
                noLabel={true}
                options={states}
                optionValue={['abbreviation']}
                optionKey={'abbreviation'}
                disabled={false}
            />

            <FormTextInput
                // formData={formData}
                name="license_year"
                value={extraLicenseYear?.[count]}
                handleChange={handleChange}
                placeholder="Year"
                required={false}
                labelSize={0}
                textSize={3}
                noLabel={true}
                disabled={false}
            />
        </>
    );
}
